import styled from 'styled-components';
import { ConfirmExecuteLog } from 'components/parts/help/confirmExecuteLog';
import { RegisterExecuteKey } from 'components/parts/help/registerExecuteKey';
import { UpdateExecuteKey } from 'components/parts/help/updateExecuteKey';
import { ScenarioSetting } from 'components/parts/help/scenarioSetting';
import { IssueRefreshToken } from 'components/parts/help/issueRefreshToken';
import '../css/help.css';

const HelpLayout = styled.div`
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  padding: 10px;
  position: relative;
  width: 100vw;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: bold;
`;

const TopicList = styled.div`
  padding: 20px;
`;

const TopicItem = styled.div`
  margin-top: 20px;
`;

const SubTitle = styled.h2`
  border-left: 5px solid rgb(211,29,62);
  padding-left: 20px;
}
`;

export const Help = () => {
  return (
    <HelpLayout>
      <Title>操作ガイド</Title>
      <TopicList>
        <TopicItem>
          <SubTitle>初めての方へ</SubTitle>
          <details>
            <summary>
              <span className="summary_inner">
                認証情報の発行<span className="icon"></span>
              </span>
            </summary>
            <div className="content">
              <IssueRefreshToken />
            </div>
          </details>
          <details>
            <summary>
              <span className="summary_inner">
                execute-Keyの登録<span className="icon"></span>
              </span>
            </summary>
            <div className="content">
              <RegisterExecuteKey />
            </div>
          </details>
          <details>
            <summary>
              <span className="summary_inner">
                RICOH Chatbot Serviceのシナリオ設定
                <span className="icon"></span>
              </span>
            </summary>
            <div className="content">
              <ScenarioSetting />
            </div>
          </details>
        </TopicItem>
        <TopicItem>
          <SubTitle>管理サイトの使い方</SubTitle>
          <details>
            <summary>
              <span className="summary_inner">
                実行ログの確認方法<span className="icon"></span>
              </span>
            </summary>
            <div className="content">
              <ConfirmExecuteLog />
            </div>
          </details>
          <details>
            <summary>
              <span className="summary_inner">
                execute-Keyの再発行<span className="icon"></span>
              </span>
            </summary>
            <div className="content">
              <UpdateExecuteKey />
            </div>
          </details>
        </TopicItem>
      </TopicList>
    </HelpLayout>
  );
};
